import React from 'react';
import {Helmet} from "react-helmet";

function Header() {

    return(


    <Helmet>
        <main>
        <title>Caroline Zaini</title>
        <meta name="description" content="Caroline Zaini web site" />
        <meta http-equiv="Content-Type" content="text/html; charset=utf-8" />
        </main>
    </Helmet>


    

    )
}

export default Header;